import { InputType } from 'config'

export const participationInputs = (): Record<string, InputType> => {
  return {
    participantName: {
      inputType: 'text',
      type: 'text',
      title: 'Investor Name',
      value: '',
      required: true,
    },
    participantRepName: {
      inputType: 'text',
      type: 'text',
      title: 'Investor Rep Name',
      value: '',
      required: true,
    },
    participantRepTitle: {
      inputType: 'text',
      type: 'text',
      title: 'Investor Rep Title',
      value: '',
      required: true,
    },
    participantAddress: {
      inputType: 'Map',
      title: 'Investor Address',
      value: '',
      required: true,
    },
    participantAmount: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Investment Amount',
      prefix: '$',
      value: '',
      required: true,
    },
    participantServicingFee: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Investor Servicing Fee',
      prefix: '$',
      value: '',
      required: true,
    },
    participantServicingFeePercent: {
      inputType: 'text',
      type: 'number',
      title: 'Servicing Fee Percent (of interest)',
      prefix: '%',
      value: '', // default 0 — total servicing fee = flat fee + interest × this percent
      required: false,
    },
    principalRate: {
      inputType: 'text',
      type: 'number',
      title: 'Principal Rate',
      prefix: '%',
      value: '', // default interest rate
      required: true,
    },
    principalBuyoutRate: {
      inputType: 'text',
      type: 'number',
      title: 'Principal Buyout Rate',
      prefix: '%',
      value: '', // default interest rate
      required: true,
    },
    participantInterestRate: {
      inputType: 'text',
      type: 'number',
      title: 'Investor Interest Rate',
      prefix: '%',
      value: '',
      required: true,
      tooltip:
        'What this investor is owed, which can be less than the borrower pays. Their share of each ' +
        'payment is scaled by this rate over the loan rate, so leaving it at the loan rate pays them ' +
        'their full share of the interest collected.',
    },
    receivesInterestSpread: {
      inputType: 'checkbox',
      title: 'Receives the interest spread',
      value: false,
      tooltip:
        'For a loan sold down at a strip: where another investor is owed less than the loan rate, the ' +
        'interest left over is paid to this investor instead of being kept by the servicer. Set it on ' +
        'the lender of record, who is owed the strip even when they hold none of the balance.',
    },
    interestSpreadSharePercent: {
      inputType: 'text',
      type: 'number',
      title: 'Share of the Interest Spread',
      prefix: '%',
      value: '',
      tooltip:
        'How much of the spread this investor takes, as a percentage OF THE SPREAD rather than a ' +
        'rate: on a 12% note sold at 10% the spread is 2%, so 25 here is a quarter of it. Only read ' +
        'when "Receives the interest spread" is ticked. Leave it blank and the spread divides as it ' +
        'did before - whoever states a share takes it and the rest is split between those that do ' +
        'not - and whatever no share is stated for stays with the servicer.',
    },
    participantExcessReturnPercent: {
      inputType: 'text',
      type: 'number',
      title: 'Investor Excess Return Percent',
      prefix: '%',
      value: '', // default 0
      required: true,
    },
    participantExtensionPercent: {
      inputType: 'text',
      type: 'number',
      title: 'Investor Extension Percent',
      prefix: '%',
      value: '', // default 0
      required: true,
    },
    participantOriginationFeePercent: {
      inputType: 'text',
      type: 'number',
      title: 'Investor Origination Fee Percent',
      prefix: '%',
      value: '', // default 0
      required: true,
    },
  }
}
